import { type IRentableUnit, RentableUnit, type RentableUnitStates, type RentingStates } from '@condo/domain';
import type {
    CreateRentableUnitProcessMutationRequest,
    CreateRentableUnitProcessMutationResponse,
    CreateRentingProcessMutationResponse,
    CreateRoomRentableUnitMutationResponse,
    GetRentableUnitQueryResponse,
    RentableUnitExternalRelations,
    UpdateRentableUnitMutationRequest,
    UpdateRentableUnitsEstarCoreIdMutationRequest,
} from '@condo/sdk/propx';
import { getClient } from './api-client';

export const getRentableUnits = async (estateId: number, onlyActive?: boolean): Promise<RentableUnit[]> =>
    getClient('propx')
        .findRentableUnits({ estateId, onlyActive, externalRelations: ['estateElement', 'parkingSpace'] as RentableUnitExternalRelations[] })
        .then(data => data.rentableUnits.map(rentableUnit => new RentableUnit(rentableUnit as IRentableUnit)));

export const getActiveRentableUnits = async (estateId: number): Promise<RentableUnit[]> => getRentableUnits(estateId, true);

export const updateRentableUnit = async (rentableUnitId: number, rentableUnit: UpdateRentableUnitMutationRequest): Promise<void> => {
    await getClient('propx').updateRentableUnit({ rentableUnit: { ...rentableUnit, rentableUnitId } });
};

export const updateRentableUnitsEstarCoreId = async (data: UpdateRentableUnitsEstarCoreIdMutationRequest): Promise<void> => {
    await getClient('propx').updateRentableUnitsEstarCoreId(data);
};

export const getRoomRentableUnit = async (estateElementId: number): Promise<GetRentableUnitQueryResponse | null> =>
    getClient('propx').getRentableUnit({ estateElementId });

export const getParkingRentableUnit = async (parkingSpaceId: number, expandOpts: any): Promise<GetRentableUnitQueryResponse | null> =>
    getClient('propx').getRentableUnit({ parkingSpaceId, expandOpts });

export const createRoomRentableUnit = async (estateElementId: number, estateId: number): Promise<CreateRoomRentableUnitMutationResponse> =>
    getClient('propx').createRoomRentableUnit({ rentableUnit: { estateElementId, estateId } });

export const createRentableUnitProcess = async (data: CreateRentableUnitProcessMutationRequest): Promise<CreateRentableUnitProcessMutationResponse> =>
    getClient('propx').createRentableUnitProcess(data);

export const createRentingProcess = async (rentableUnitId: number, processState?: RentingStates): Promise<CreateRentingProcessMutationResponse> =>
    getClient('propx').createRentingProcess({ rentableUnitId, processState });

export const deleteRentingProcess = async (rentingProcessId: number): Promise<void> => {
    await getClient('propx').deleteRentingProcess({ rentingProcessId });
};

export const deleteRoomRentableUnit = async (estateElementId: number): Promise<void> => {
    await getClient('propx').deleteRoomRentableUnit({ estateElementId });
};
export const deleteRentableUnit = async (rentableUnitId: number): Promise<void> => {
    await getClient('propx').deleteRentableUnitById({ rentableUnitId });
};
